/**
 * Project-wide TanStack Query client singleton.
 *
 * @module queryClient
 *
 * @remarks
 * Import this instance wherever a {@link QueryClient} reference is needed
 * (e.g. manual cache invalidation outside React components).
 *
 * ## Default cache behaviour
 * | Option | Value | Rationale |
 * |---|---|---|
 * | `staleTime` | 60 s | Avoids redundant refetches on tab-focus / component remount |
 * | `gcTime` | 5 min | Keeps unused cache entries alive across short navigations |
 * | `retry` | 1 | One silent retry on transient network failure |
 *
 * Override per-query by passing `staleTime` / `gcTime` / `retry` directly to `useQuery`.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
    },
  },
});
